import type { ISendbirdConnectionCredentials, ISendbirdSessionPayload } from '../types/sendbirdTypes';

const EXPIRY_BUFFER_MS = 60_000;

export type SendbirdConnectContext = {
  isNewModelChannel: boolean;
  vendorSendBirdId: string | null;
  teamMemberSendbirdId: string | null;
};

export function isSendbirdSessionExpired(expiresAt: number | null | undefined): boolean {
  if (expiresAt == null) return true;
  return Date.now() >= expiresAt - EXPIRY_BUFFER_MS;
}

export function toConnectionCredentials(session: ISendbirdSessionPayload): ISendbirdConnectionCredentials {
  return {
    applicationId: session.applicationId,
    userId: session.sendbirdId,
    accessToken: session.accessToken,
  };
}

export function resolveSendbirdSdkUserId(ctx: SendbirdConnectContext): string {
  if (ctx.isNewModelChannel) {
    return ctx.teamMemberSendbirdId ?? ctx.vendorSendBirdId ?? '';
  }
  return ctx.vendorSendBirdId ?? ctx.teamMemberSendbirdId ?? '';
}

export function buildSessionTokenUrl(
  basePath: string,
  sdkUserId: string,
  teamMemberSendbirdId: string,
): string {
  if (sdkUserId && sdkUserId !== teamMemberSendbirdId) {
    return `${basePath}?sendbirdUserId=${encodeURIComponent(sdkUserId)}`;
  }
  return basePath;
}

export function isLegacySendbirdChannel(isNewModelChannel: boolean | undefined): boolean {
  return isNewModelChannel !== true;
}
